import Vue from 'vue'
import Vuex from 'vuex'
import fa from "element-ui/src/locale/lang/fa";

// this.$store
// this.$store.state.xxx
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    currentIndex: 0,
    childIndex: 0,
    isSlide: true,
    isAlpha: false,
    isPc: true,
    isTouchMove: true,
  },
  mutations: {
    editIndex(state,payload){
      state.currentIndex = payload
    },
    edit(state,payload){
      state.childIndex = payload
    },
    slideEdit(state,payload){
      state.isSlide = payload
    },
    isAlphaEdit(state,payload){
      state.isAlpha = payload
    },
    isPCEdit(state,payload){
      state.isPc = payload
    },
    touchMove(state,payload){
      state.isTouchMove = payload
    },
  },

  actions: {
  },
  modules: {
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js